export default __webpack_public_path__ + "static/media/production-lines-icon.9b90322a.svg";